import React from 'react';
import PropTypes from 'prop-types';
import './Typography.scss';

/*
  if (component) {
    return React.createElement(
      component,
      {
        className: classNames([
          classes["typography-root"],
          classes[`typography-${variant}`],
          className ? className : "",
        ]),
        ...props,
      },
      [children]
    );
  }
  */

export const Typography = ({ variant, bold, children, className, color, inline, ...rest }) => {
  const classNameCommon = `mb-0 ${color || ''} ${className || ''} ${bold ? 'header-bold' : ''} ${inline ? 'text-inline' : ''}`;
  
  // Map variant to HTML element and additional classes
  const variantConfig = {
    h1: { element: 'h1', additionalClass: '' },
    h2: { element: 'h2', additionalClass: '' },
    h3: { element: 'h3', additionalClass: '' },
    h4: { element: 'h4', additionalClass: '' },
    h5: { element: 'h5', additionalClass: '' },
    h6: { element: 'h6', additionalClass: '' },
    display1: { element: 'h1', additionalClass: 'display-1' },
    display2: { element: 'h2', additionalClass: 'display-2' },
    display3: { element: 'h3', additionalClass: 'display-3' },
    display4: { element: 'h4', additionalClass: 'display-4' },
    display5: { element: 'h5', additionalClass: 'display-5' },
    display6: { element: 'h6', additionalClass: 'display-6' },
    lead: { element: 'p', additionalClass: 'lead' },
    small: { element: 'p', additionalClass: 'small' },
    p: { element: 'p', additionalClass: '' }
  };

  // Get configuration for current variant or default to paragraph
  const config = variantConfig[variant] || variantConfig.p;
  const Element = config.element;
  const fullClassName = `${classNameCommon} ${config.additionalClass}`.trim();

  return (
    <Element className={fullClassName} {...rest}>
      {children}
    </Element>
  );
};

Typography.propTypes = {
  bold: PropTypes.bool,
  variant: PropTypes.oneOf([
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'display1', 'display2', 'display3', 'display4', 'display5', 'display6',
    'p', 'lead', 'small'
  ]),
  color: PropTypes.oneOf([
    'text-default', 'text-muted', 'text-primary', 'text-info',
    'text-success', 'text-warning', 'text-danger', 'text-dark'
  ]),
  inline: PropTypes.bool,
};

Typography.defaultProps = {
  variant: 'p',
  bold: false,
  inline: false,
};
